/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';
import { unitAttributesEntity } from './unitAttribute.schema';
import { unitInventoriesEntity } from './unitInventory.schema';

export const unitsEntity = new schema.Entity('units', {
  unit_attributes: [unitAttributesEntity],
  unit_inventories: [unitInventoriesEntity]
});
